import { get } from 'lodash';
export var getButtonMaxWidth = function (css, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = undefined; }
    return get(css, 'so-global-b1.maxWidth') || fallbackValue || '300px';
};
export var getButtonMinWidth = function (css, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = undefined; }
    return get(css, 'so-global-b1.minWidth') || fallbackValue || '140px';
};
//# sourceMappingURL=button-utils.js.map